import { useMutation } from '@tanstack/react-query';
import type { SendSelfTestPushBody, SendSelfTestPushResult } from '@restaurant/api-client';
import { openapiClient, unwrapResult } from '@/api/openapi-client';

/**
 * "Send me a test push" from the notification-settings screen. The backend
 * always targets the caller's own registered devices and returns as soon as the
 * delayed send is scheduled - so the operator can leave the app and watch the
 * real banner land `delaySeconds` later.
 *
 * `scheduled: false` means the account has no active device token yet (push not
 * enabled on any device), not a failure.
 */
export function useSendTestPush() {
  return useMutation({
    mutationFn: async (input: SendSelfTestPushBody) =>
      unwrapResult<SendSelfTestPushResult>(
        await openapiClient.POST('/api/notifications/test-push/self', { body: input }),
      ),
  });
}
